import { useMediaQuery, useTheme } from "@mui/material";

const useScreen = () => {
  const theme = useTheme();

  return {
    isMobile: useMediaQuery(theme.breakpoints.down("sm")),
    isTablet: useMediaQuery(theme.breakpoints.between("sm", "lg")),
    isDesktop: useMediaQuery(theme.breakpoints.up("md")),
    isXl: useMediaQuery(theme.breakpoints.up("xl")),
  };
};

export default useScreen;
